module.exports = {
  /** Site MetaData (Required all)*/
  title: `fkfkfk9 Learn CODE`,                           // (* Required)
  description: `유종현의 개발 공부용 블로그`,          // (* Required)
  author: `fkfkfk9`,                         // (* Required)
  language: 'ko-KR',                        // (* Required) html lang, ex. 'en' | 'en-US' | 'ko' | 'ko-KR' | ...
  siteUrl: 'https://fkfkfk9.github.io',                      // (* Required)

  /** Header */
  profileImageFileName: 'main_img.jpg', // include filename extension ex.'profile.jpg'
    // The Profile image file is located at path "./images/"
    // If the file does not exist, it is replaced by a random image.

  /** Home > Bio information*/
  comment: 'eGov,Spring 개발자 May 2018 ~',
  name: '유종현',
  company: '(주)한시스템',
  location: 'Korea',
  email: 'fkfkfk9@kakao.com',
  website: 'https://github.com/fkfkfk9/fkfkfk9.github.io',           // ex.'https://junhobaik.github.io'
  linkedin: 'https://www.linkedin.com/in/%EC%A2%85%ED%98%84-%EC%9C%A0-99063119b/',                                                          // ex.'https://www.linkedin.com/in/junho-baik-16073a19ab'
  facebook: '',                                                          // ex.'https://www.facebook.com/zuck' or 'https://www.facebook.com/profile.php?id=000000000000000'
  instagram: '',                                                         // ex.'https://www.instagram.com/junhobaik'
  github: 'https://github.com/fkfkfk9',                                                            // ex.'https://github.com/junhobaik'

  /** Post */
  enablePostOfContents: true,     // TableOfContents activation (Type of Value: Boolean. Not String)
  disqusShortname: '',            // comments (Disqus sort-name)
  enableSocialShare: true,        // Social share icon activation (Type of Value: Boolean. Not String)

  /** Optional */
  googleAnalytics: 'G-NHNE0QZVKG',     // Google Analytics TrackingID. ex.'UA-123456789-0'
  googleSearchConsole: '', // content value in HTML tag of google search console ownership verification. ex.'w-K42k14_I4ApiQKuVPbCRVV-GxlrqWxYoqO94KMbKo'
  googleAdsenseSlot: '',   // Google Adsense Slot. ex.'5214956675'
  googleAdsenseClient: 'ca-pub-5143454690757819', // Google Adsense Client. ex.'ca-pub-5001380215831339'
    // Please correct the adsense client number(ex.5001380215831339) in the './static/ads.txt' file.
};
